import { useCriarObraAcao } from "./use-criar-obra-acao";
import { CriarObraAcaoView } from "./view-criar-obra-acao";
import type { CriarObraAcaoProps } from "./types-criar-obra-acao";

export function CriarObraAcao(props: CriarObraAcaoProps) {
  const vm = useCriarObraAcao(props);

  return <CriarObraAcaoView {...props} {...vm} />;
}

export type * from "./types-criar-obra-acao";
